import { Serializer } from "../resource/serializer.interface";
import { PreferenceCatalog } from "./preference-catalog.model";
import { PreferenceOptionSerializer } from "../preference-option/preference-option-serializer.class";

export class PreferenceCatalogSerializer implements Serializer {
    private optionSerializer: PreferenceOptionSerializer = new PreferenceOptionSerializer();

    fromJson(json: any): PreferenceCatalog {
        const preferenceCatalog = new PreferenceCatalog();
        preferenceCatalog.id = json.id;
        preferenceCatalog.name = json.name;
        preferenceCatalog.code = json.code;
        preferenceCatalog.dependsOn = json.dependsOn;
        preferenceCatalog.dependsOnLogic = json.dependsOnLogic;
        preferenceCatalog.status = json.status;
        // A catalog with no options is a savable state in the catalog editor, and the API may
        // return `options` as null or omit it entirely. Mapping that unguarded threw a TypeError
        // inside convertData(), which failed the whole list() call: every catalog disappeared from
        // the Core Preference dropdown at once, with no error shown anywhere.
        preferenceCatalog.options = (json.options ?? []).map((option: any) => this.optionSerializer.fromJson(option));
        preferenceCatalog.tenantId = json.tenant_id;
        return preferenceCatalog;
    }

    toJson(preferenceCatalog: PreferenceCatalog): any {
        return {
            id: preferenceCatalog.id,
            name: preferenceCatalog.name,
            code: preferenceCatalog.code,
            dependsOn: preferenceCatalog.dependsOn,
            dependsOnLogic: preferenceCatalog.dependsOnLogic,
            status: preferenceCatalog.status,
            options: (preferenceCatalog.options ?? []).map(option => this.optionSerializer.toJson(option)),
            tenant_id: preferenceCatalog.tenantId
        };
    }
}
